// Set up your root reducer here...
import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import studentDetailsReducer from "./studentDetailsReducer";
import universityDetailsReducer from "./universityDetailsReducer";
import commonReducer from "./commonReducer";
import upcomingEventsReducer from "./upcomingEventsReducer";
import registeredEventsReducer from "./registeredEventsReducer";
import meetingsReducer from "./meetingsReducer";
import notesReducer from "./notesReducer";
import reportsReducer from "./reportsReducer";

const createRootReducer = (history) =>
    combineReducers({
        router: connectRouter(history),
        studentDetails: studentDetailsReducer,
        universityDetails: universityDetailsReducer,
        common: commonReducer,
        upcomingEvents: upcomingEventsReducer,
        registeredEvents: registeredEventsReducer,
        meetings: meetingsReducer,
        notes: notesReducer,
        reports: reportsReducer,
    });

export default createRootReducer;
